import styled from 'styled-components'
import { CommonLabel } from '../styles';

export const Div = styled(CommonLabel)`
  color: #666666;
  font-size: 1.4rem;
  grid-area: ${props => props.gridArea || ''};
`;
